module.exports = __webpack_public_path__ + "static/tender-is-the-night-6624521e8e918ef5fdcacd5f780cf5ab.jpg";